import LoginContent from "../../components/getStarted/loginContent";
// starting redux stuff ...
import store from '../../store';
import { createWrapper } from 'next-redux-wrapper';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
const HeadContent = dynamic(() => import('../../hoc/headContent'), { loading: () => <></>, ssr: true });
// ending redux stuff ...

function Login(props) {
	const router = useRouter();
	const meta = {
		title: "Login | Bayan",
		description: "Where would you like to login to?",
		route: "login",
	}
	return (
		<>
				<HeadContent
					title={meta.title}
					description={meta.description}
					route={meta.route}
				/>
			<LoginContent router={props.router} routerObj={router} />
		</>
	);
}

const makeStore = () => store;
const wrapper = createWrapper(makeStore);

export default wrapper.withRedux(Login);

